import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.MANAGEMENT_LOGS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.MANAGEMENT_LOGS}/${id}`,
    method: "get",
  });
}

export default {
  list,
  show,
};
